export default "__VITE_ASSET__CdeN4IlI__"